<script lang="ts">
	import { SeriesPage } from '#lib/websites/editions/pages/SeriesPage/index.js';
</script>

<SeriesPage />
